import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const MAX_MINUTES = 6 * 60; // 6 hours in minutes

export const useTemplateEntryTimeValues = (
  blockSize: number,
  disableFirst: boolean = false
) => {
  const intl = useIntl();

  const data = useMemo(() => {
    if (blockSize <= 0) return [];
    const intervals: number[] = [];
    for (let minutes = 0; minutes <= MAX_MINUTES; minutes += blockSize) {
      intervals.push(minutes);
    }
    return intervals.map(option => ({
      key: option,
      disabled: option === 0 && disableFirst,
      title: intl.formatMessage(
        {
          id:
            option === 0
              ? 'template.entry.minutes.block'
              : 'template.entry.minutes.minutes-desc',
        },
        {
          minutes: option,
        }
      ),
    }));
  }, [blockSize, disableFirst, intl]);

  return {
    data,
    loading: false,
  };
};
